import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { bff } from '../lib/bff-client'
import { KNOWN_TENANTS } from '../types/bff'

export function HomePage() {
  // 1 query por tenant conocido — health-card entrega summary compacta.
  // Futuro: Core API expone /platform/tenants list → single call.
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Tenants</h1>
        <p className="text-sm text-slate-500">
          Click en un tenant para ver detalle + toggle sapps.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {KNOWN_TENANTS.map((t) => (
          <TenantCard key={t.id} id={t.id} label={t.label} />
        ))}
      </div>
    </div>
  )
}

function TenantCard({ id, label }: { id: string; label: string }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['tenant-health-card', id],
    queryFn: () => bff.getTenantHealthCard(id),
    staleTime: 30_000,
  })

  return (
    <Link
      to="/tenant/$tenantId"
      params={{ tenantId: id }}
      className="block rounded-lg border bg-white p-4 shadow-sm hover:border-blue-400 hover:shadow transition"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="font-semibold">{data?.name ?? label}</div>
          <div className="mt-1 text-xs text-slate-500 font-mono">{id}</div>
        </div>
        <span className="rounded bg-slate-100 px-2 py-0.5 text-xs">
          {data?.status ?? '—'}
        </span>
      </div>

      {isLoading && <div className="mt-3 text-sm text-slate-400">Cargando…</div>}

      {error && (
        <div className="mt-3 text-sm text-red-600">
          Error: {error instanceof Error ? error.message : 'unknown'}
        </div>
      )}

      {data && (
        <div className="mt-3 space-y-1 text-sm">
          <div>
            <span className="text-slate-500">Bandeja:</span> <strong>{data.bandeja_app}</strong>
          </div>
          <div>
            <span className="text-slate-500">Default sapp:</span>{' '}
            <strong>{data.default_sapp ?? '—'}</strong>
          </div>
          <div>
            <span className="text-slate-500">S-Apps enabled:</span>{' '}
            <strong>
              {data.sapps_enabled} / {data.sapps_total}
            </strong>
          </div>
          <div className="mt-2 flex flex-wrap gap-1">
            {data.sapps_enabled_slugs.map((slug) => (
              <span
                key={slug}
                className="rounded bg-green-100 px-1.5 py-0.5 text-xs text-green-800"
              >
                {slug}
              </span>
            ))}
          </div>
        </div>
      )}
    </Link>
  )
}
